import { connect } from 'react-redux';
import React, { ReactElement, Suspense } from 'react';
import { IntStore } from '../../schemas/store.interface';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { getCompany } from '../../core/local-storage/local-storage.service';
import { environment } from '../../environments/environment';
import {initRefund}from '../../schemas/refund.interface'
import { getCodeCompany } from '../user/user.service';
const Refund = (props: initRefund): ReactElement => {

  const { t } = useTranslation();
  const companyStorage = getCompany();

  const history = useHistory();
  const goBack = () => {
    history.goBack()
  }

  const vlg_rlink = t(`${companyStorage}.refund.link_url`);
  const def_rlink = `${environment.static.pdfs}/${companyStorage}/${props.user.language}/reembolso_${getCodeCompany(companyStorage)}.pdf`;

  return (
    <Suspense fallback="">
      <div className="card">
        {t(`${companyStorage}.refund.title`)}
        <a href={{ 'vueling': vlg_rlink }[companyStorage] || def_rlink} target="_blank">
          {t(`${companyStorage}.refund.link`)}
        </a>

        <div className="btn-wrapper">
          <button data-qa="submit-pir" className="btn btn--primary" id="btn-user-continue" onClick={goBack}>{t('DEFAULT_BTN_VOLVER')}</button>
        </div>
      </div>
  </Suspense>
  );
};

const mapStateToProps = (state: IntStore) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Refund);
